import React from 'react'
import Hero from './Hero'
import Brokerage from './Brokerage'
import Openaccount from '../Openaccount'

function PricingPage() {
  return (
    <div>
      <Hero/>
      <Openaccount/>
      <Brokerage/>
    </div>
  )
}

export default PricingPage
